import React from "react";
import Cookie from "js-cookie";
import axios from "@/utils/myaxios";
import moment from "moment";
import { kindList } from "@/utils/constant";
import { Link } from "react-router-dom";
import {
    Button,
    Table,
    message,
    DatePicker,
    Modal,
    Pagination,
    Select,
} from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

export default class IntegralStatistic extends React.Component {
    state = {
        loading: false, // 是否加载中
        recordLoading: false, // 流水是否加载中
        exportLoading: false, // 导出是否加载中
        exportRecordLoading: false, // 导出流水是否加载中
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            union_id: undefined,
            date: [],
        },
        subQueryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            union_id: undefined,
            game_kind: undefined,
            date: [],
        },
        kindList: kindList, // 游戏列表
        data: [], // 表格数据
        subUnionList: [], // 子联盟列表
        recordData: [], // 流水数据
    };

    componentDidMount () {
        this.fetchData();
        this.fetchSubUnionList();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/super_union_cost_point_stat", {
                params: {
                    ...this.state.queryParams,
                    union_id:
                        this.state.queryParams.union_id !== undefined
                            ? this.state.queryParams.union_id
                            : -1,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 获取子联盟列表
     */
    fetchSubUnionList = () => {
        axios.get("/v1/api/union_select_union").then((res) => {
            this.setState({
                subUnionList: res.data || [],
            });
        });
    };

    /**
     * 获取流水数据
     */
    fetchRecordData = () => {
        this.setState({ recordLoading: true });
        axios
            .get("/v1/api/super_union_cost_point_flow", {
                params: {
                    ...this.state.subQueryParams,
                    union_id:
                        this.state.subQueryParams.union_id !== undefined
                            ? this.state.subQueryParams.union_id
                            : -1,
                    game_kind:
                        this.state.subQueryParams.game_kind !== undefined
                            ? this.state.subQueryParams.game_kind
                            : 0,
                    begin_time:
                        this.state.subQueryParams.date[0] &&
                        this.state.subQueryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.subQueryParams.date[1] &&
                        this.state.subQueryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    recordLoading: false,
                    subQueryParams: {
                        ...this.state.subQueryParams,
                        total: res.count || 0,
                    },
                    recordData: res.data || [],
                });
            });
    };

    /**
     * 导出数据
     */
    handleExport = () => {
        this.setState({ exportLoading: true });
        axios
            .get("/v1/api/super_union_cost_point_stat_export", {
                params: {
                    ...this.state.queryParams,
                    union_id:
                        this.state.queryParams.union_id !== undefined
                            ? this.state.queryParams.union_id
                            : -1,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({ exportLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    /**
     * 导出流水数据
     */
    handleRecordExport = () => {
        this.setState({ exportRecordLoading: true });
        axios
            .get("/v1/api/super_union_cost_point_flow_export", {
                params: {
                    ...this.state.subQueryParams,
                    union_id:
                        this.state.subQueryParams.union_id !== undefined
                            ? this.state.subQueryParams.union_id
                            : -1,
                    game_kind:
                        this.state.subQueryParams.game_kind !== undefined
                            ? this.state.subQueryParams.game_kind
                            : 0,
                    begin_time:
                        this.state.subQueryParams.date[0] &&
                        this.state.subQueryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.subQueryParams.date[1] &&
                        this.state.subQueryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({ exportRecordLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination, type) => {
        if (type === "record") {
            // 流水数据
            this.setState(
                {
                    subQueryParams: {
                        ...this.state.subQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchRecordData()
            );
        } else {
            // 表格数据
            this.setState(
                {
                    queryParams: {
                        ...this.state.queryParams,
                        page: pagination.current,
                        limit: pagination.pageSize,
                    },
                },
                () => this.fetchData()
            );
        }
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value, type) => {
        if (type === "record") {
            // 流水数据
            this.setState({
                subQueryParams: { ...this.state.subQueryParams, page: 1, [key]: value },
            });
        } else {
            // 表格数据
            this.setState({
                queryParams: { ...this.state.queryParams, page: 1, [key]: value },
            });
        }
    };

    /**
     * 重置
     */
    handleReset = (type) => {
        if (type === "record") {
            // 流水数据
            this.setState(
                {
                    subQueryParams: {
                        page: 1,
                        limit: 20,
                        total: 0,
                        union_id: undefined,
                        game_kind: undefined,
                        date: [],
                    },
                },
                () => {
                    this.fetchRecordData();
                }
            );
        } else {
            // 表格数据
            this.setState(
                {
                    queryParams: {
                        page: 1,
                        limit: 20,
                        total: 0,
                        union_id: undefined,
                        date: [],
                    },
                },
                () => {
                    this.fetchData();
                }
            );
        }
    };

    /**
     * 显示弹窗
     */
    handleShow = () => {
        this.setState(
            {
                show: true,
                title: this.props.language["intergralConsumeRecord"],
                recordData: [],
                subQueryParams: {
                    ...this.state.subQueryParams,
                    page: 1,
                },
            },
            () => this.fetchRecordData()
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["unionPlaceholder"]}
                        value={this.state.queryParams.union_id}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("union_id", value)
                        }
                    >
                        {this.state.subUnionList.map((item, index) => (
                            <Select.Option value={item.union_id} key={index}>
                                {item.name}
                            </Select.Option>
                        ))}
                    </Select>
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData("date", e)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button
                        type="default"
                        icon="arrow-down"
                        className="btn-yellow-ghost"
                        loading={this.state.exportLoading}
                        onClick={this.handleExport}
                    >
                        {this.props.language["exportExcel"]}
                    </Button>
                    <Button type="primary" ghost onClick={this.handleShow}>
                        {this.props.language["intergralConsumeRecord"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={tableSummaries(this.state.data, "day")}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["date"]}
                            dataIndex="day"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cusomeOrigin"]}
                            dataIndex="origin"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["totalCusome"]}
                            dataIndex="total_cost"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["nlhFee"]}
                            dataIndex="nlh_fee"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["nhlInsurance"]}
                            dataIndex="nlh_ins"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sixFee"]}
                            dataIndex="six_fee"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sixInsurance"]}
                            dataIndex="six_ins"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ploFee"]}
                            dataIndex="plo_fee"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ploInsurance"]}
                            dataIndex="plo_ins"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["aof"]}
                            dataIndex="aof"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyInsurance"]}
                            dataIndex="cowboy"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ofc"]}
                            dataIndex="ofc"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["mttManage"]}
                            dataIndex="mtt"
                        />
                        {Cookie.get("isKpoker") === 'true' && Cookie.get("identityType") !== 'super_union_admin_houtong' &&
                            <Table.Column
                                align="center"
                                title={this.props.language["apiPropCusome"]}
                                dataIndex="api_prop_cost_sum"
                            />
                        }
                    </Table>
                    <Pagination
                        className="pagination"

                        showQuickJumper
                        showSizeChanger
                        size={isMobileDevice() ? 'small' : ''}
                        showTotal={(total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                        }
                        pageSizeOptions={["10", "20", "30", "40"]}
                        current={this.state.queryParams.page}
                        pageSize={this.state.queryParams.limit}
                        total={this.state.queryParams.total}
                        onChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                        onShowSizeChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                    />
                </div>

                {/* 查看流水弹窗 */}
                <RecordModal
                    {...this.props}
                    visible={this.state.show}
                    title={this.state.title}
                    loading={this.state.recordLoading}
                    exportRecordLoading={this.state.exportRecordLoading}
                    subQueryParams={this.state.subQueryParams}
                    pagination={{
                        showTotal: (total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                        showQuickJumper: true,
                        current: this.state.subQueryParams.page,
                        pageSize: this.state.subQueryParams.limit,
                        total: this.state.subQueryParams.total,
                        size: isMobileDevice() ? 'small' : '',
                    }}
                    recordData={this.state.recordData}
                    subUnionList={this.state.subUnionList}
                    kindList={this.state.kindList}
                    handleSetQueryParamsData={this.handleSetQueryParamsData}
                    handleReset={this.handleReset}
                    fetchRecordData={this.fetchRecordData}
                    handleRecordExport={this.handleRecordExport}
                    onCancel={() => this.setState({ show: false })}
                    onChange={(pagination) =>
                        this.hanldeChangePage({ current: pagination }, "record")
                    }
                />
            </div>
        );
    }
}

/**
 * 查看流水弹窗
 */
class RecordModal extends React.Component {
    render () {
        return (
            <Modal
                maskClosable={false}
                width={1600}
                title={this.props.title}
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: '70vh',
                    overflowY: "auto",
                }}
                footer={
                    <Pagination

                        showQuickJumper
                        {...this.props.pagination}
                        showTotal={(total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                        }
                        onChange={this.props.onChange}
                    />
                }
            >
                {/* 表头 */}
                <div className="container-header">
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        className="mr10"
                        placeholder={this.props.language["unionPlaceholder"]}
                        value={this.props.subQueryParams.union_id}
                        onChange={(value) =>
                            this.props.handleSetQueryParamsData("union_id", value, "record")
                        }
                    >
                        {this.props.subUnionList.map((item, index) => (
                            <Select.Option value={item.union_id} key={index}>
                                {item.name}
                            </Select.Option>
                        ))}
                    </Select>
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        className="mr10"
                        placeholder={this.props.language["gameTypePlaceholder"]}
                        value={this.props.subQueryParams.game_kind}
                        onChange={(value) =>
                            this.props.handleSetQueryParamsData("game_kind", value, "record")
                        }
                    >
                        {this.props.kindList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <DatePicker.RangePicker
                        className="mr10"
                        value={this.props.subQueryParams.date}
                        onChange={(e) =>
                            this.props.handleSetQueryParamsData("date", e, "record")
                        }
                    />
                    <Button
                        type="primary"
                        icon="search"
                        className="mr10"
                        onClick={this.props.fetchRecordData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button
                        type="default"
                        icon="reload"
                        className="mr10"
                        onClick={() => this.props.handleReset("record")}
                    >
                        {this.props.language["reset"]}
                    </Button>
                    <Button
                        type="default"
                        icon="arrow-down"
                        className="btn-yellow-ghost"
                        loading={this.props.exportRecordLoading}
                        onClick={this.props.handleRecordExport}
                    >
                        {this.props.language["exportExcel"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.props.recordData}
                        pagination={false}
                        loading={this.props.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["date"]}
                            dataIndex="date_time"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cusomeAmount"]}
                            dataIndex="amount"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cusomeOrigin"]}
                            dataIndex="origin"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gameType"]}
                            dataIndex="game_kind"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["consumeType"]}
                            dataIndex="cost_type"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gambleId"]}
                            dataIndex="mid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["item"]}
                            dataIndex="hid"
                        />
                    </Table>
                </div>
            </Modal>
        );
    }
}
